import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getWalletProfilesV2 } from 'services/CustomerService'
import { GetCustomerWalletProfilesRequest } from 'types/customers'

export const useGetCustomersWalletProfileQuery = (request?: GetCustomerWalletProfilesRequest) => {
  return useQuery({
    queryKey: reactQueryKeys.customerWalletProfiles(request),
    queryFn: () => getWalletProfilesV2(request),
  })
}
